import { Switch } from "@material-ui/core";
import React from "react";
import { CustomSwitchContainer } from "./CustomSwitch.styles";

const CustomSwitch = ({ label, checked, disabled, onChange, theme }) => {
  const color = theme?.circleButton ? theme.circleButton : "#0080C0";
  return (
    <CustomSwitchContainer
      control={
        <Switch
          style={{ color: checked ? color : "#dedede" }}
          checked={checked}
          size="small"
          color="primary"
          onClick={onChange}
          disabled={disabled}
        />
      }
      label={label}
    />
  );
};

export default CustomSwitch;
